import React, { useMemo } from 'react'
import { NavLink, generatePath } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import cn from 'classnames'

import { IStoreProfile } from 'interfaces'
import { APP_URL } from 'config/app'
import { useFetchStorePopularGoods } from 'containers/Store/hooks'
import { Catalog } from 'containers'

import styleButton from 'components/Button/Button.module.css'
import style from './StoreProfileContent.module.css'

type StoreProfileContentPropType = {
    profile?: IStoreProfile
}

const StoreProfileContent: React.FC<StoreProfileContentPropType> = ({ profile }) => {
    const { t } = useTranslation()

    const catalogUrl = useMemo(() => {
        return profile ? generatePath(APP_URL.store, { id: profile.id }) : ''
    }, [profile])

    const {
        data: dataStorePopularGoods,
    } = useFetchStorePopularGoods({
        storeId: profile?.id ?? 0,
    }, {
        enabled: !!profile?.id,
    })

    return (
        <>
            {profile && (
                <>
                    {!!dataStorePopularGoods?.length && (
                        <h2 className={style.title}>
                            {t('search_popular')}
                        </h2>
                    )}
                    <Catalog
                        isSetItemLink
                        isShowBuyButton
                        isShowEmptyText={false}
                        storeProfile={profile}
                        data={dataStorePopularGoods}
                    />
                </>
            )}

            {catalogUrl && (
                <div className={style.controls}>
                    <NavLink
                        className={cn(
                            styleButton.default,
                            styleButton.size44,
                        )}
                        to={catalogUrl}
                    >
                        {t('button_store_catalogue')}
                    </NavLink>
                </div>
            )}
        </>
    )
}

export default StoreProfileContent
